import React, { Component } from 'react'
import axios from '../../axios'
import qs from 'qs'
import queryString from 'query-string'
import moment from 'moment'
import { extendMoment } from 'moment-range'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';


class ExportGuru extends Component {
    constructor() {
        super();
        this.intervalId = null;
        this.state = {
            dataKelas : [],
            dataMapel : [],
            dataExport   : [],
            dataGuru : [],
            dataReport : [],
            pageCount : 0,
            currentPage : 0,
            user_id : "",
            kelas_id : "",
            mapel_id : "",
            isLoading : true,
            isButtonLoading: false,
            isModalShow : false,
            isButtonExport : false,
            dKelas  : '',
            textGenerate : '',
            created_at:'',
            idQueue:'',
            count: 0,
            delay: 10000,
        }

        this.generateExport = this.generateExport.bind(this)
        this.getQueue = this.getQueue.bind(this)

    }

    generateExport(){
        this.setState({ isButtonLoading:true, isLoading:true, isButtonExport: true });
        let sortirLevel;
        sortirLevel = "guru";
        const urlParams = queryString.parse(this.props.location.search);

        const params = qs.stringify({
            // user : this.state.user_id,
            level: sortirLevel,
            user : urlParams.user,
            tglMulai : urlParams.tglMulai,
            tglEnd : urlParams.tglEnd,

        })

        axios.post("/reportgurunew?" + params)
            .then(response => {
                const result = response.data;
                if (result.success) {
                    this.setState({
                        idQueue:result.data,
                        isButtonLoading: false,
                        textGenerate: result.message,
                        isLoading: false,
                        isButtonExport: false
                    },()=>{
                        this.intervalId = setInterval(this.getQueue, this.state.delay);
                    })

                } else {
                    this.setState({isButtonLoading: false, isLoading: false, isButtonExport: false});
                }

            })
            .catch((error) => {
                console.log(error)
                this.setState({isButtonLoading: false, isLoading: false, isButtonExport: false})
            })
    }

    loadExport() { //guru

        this.setState({ isButtonExport:true, isLoading: true });
        let sortirLevel;
        sortirLevel = "guru";
        const urlParams = queryString.parse(this.props.location.search);

        const params = qs.stringify({
            // user : this.state.user_id,
            level: sortirLevel,
            user : urlParams.user,
            tglMulai : urlParams.tglMulai,
            tglEnd : urlParams.tglEnd,

        })

        axios.post("/downloadreportguru?" + params)
            .then(response => {
                const result = response.data;
                if (result.success) {
                    clearInterval(this.intervalId);
                    this.setState({
                        idQueue:'',
                        dataExport: result.data,
                        created_at: result.created_at,
                        dKelas: result.kelas,
                        isButtonExport: false,
                        isButtonLoading: false,
                        isLoading: false
                    })

                } else {
                    this.setState({isButtonExport: false, isLoading: false, isButtonLoading: false},()=>{
                        this.intervalId = setInterval(this.getQueue, this.state.delay);
                    });
                }

            })
            .catch((error) => {
                console.log(error)
                this.setState({isButtonExport: false, isLoading: false, isButtonLoading: false})
            })
    }

    getQueue(){
        this.setState({ isButtonLoading:true });
        if (this.state.idQueue === ''){
            return false;
        }

        const urlParams = queryString.parse(this.props.location.search);
        const params = qs.stringify({
            idque: this.state.idQueue,
            level: 'guru',
            dateStart: urlParams.tglMulai,
            dateEnd: urlParams.tglEnd
        })

        axios.post("/checkqueue?" + params)
            .then(response => {
                const result = response.data;
                if (result.success) {
                    clearInterval(this.intervalId);
                    this.setState({
                        idQueue:'',
                        isButtonLoading: false,
                        textGenerate: result.message,
                        isLoading: false,
                        isButtonExport:false
                    },()=>{
                        this.loadExport();
                    })
                } else {
                    this.setState({
                        idQueue:this.state.idQueue,
                        isButtonLoading: true,
                        textGenerate: result.message,
                        isLoading: true,
                        isButtonExport:true,
                        counter:this.state.counter +1
                    })
                }

            })
            .catch((error) => {
                console.log(error)
                this.setState({isButtonLoading: false, isLoading: false})
            })
    }

    componentDidMount() {

        let sortirLevel;
        sortirLevel = "guru";
        if (this.state.idQueue !== ''){
            this.intervalId = setInterval(this.getQueue, this.state.delay);
        }
        this.loadExport();

    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.delay !== this.state.delay) {
            clearInterval(this.intervalId);
            this.intervalId = setInterval(this.getQueue, this.state.delay);
        }
    }

    render() {
        let levelName;
        let kelas;
        let no = 1;

        const urlParams = queryString.parse(this.props.location.search);
        const momentRange = extendMoment(moment);
        const range = momentRange.range(moment(urlParams.tglMulai), moment(urlParams.tglEnd));
        const arrayDate = Array.from(range.by('day'));

        kelas = null;
        levelName = "Guru";
        return (

            <div className="col-sm-12">

                <div className="card">
                    <div className="card-header">
                        Export Presensi {levelName}
                    </div>
                    <div className="card-block">
                        <div>
                            {
                                this.state.isButtonExport || this.state.idQueue > 0 ? (
                                    <div className="alert alert-info" role="alert" style={{ textAlign:'center' }}>
                                        <div className="loader" style={{
                                            borderLeft: '15px solid #20a8d8'
                                        }}></div>
                                        File Sedang disiapkan, Mohon menunggu..
                                    </div>
                                ) : (
                                    this.state.dataExport.length === 0 ? (
                                        this.state.isButtonExport || this.state.idQueue > 0 ? (
                                            <div className="alert alert-info" role="alert" style={{ textAlign:'center' }}>
                                                <div className="loader" style={{
                                                    borderLeft: '15px solid #20a8d8'
                                                }}></div>
                                                File Sedang disiapkan, Mohon menunggu..
                                            </div>
                                        ) : (
                                            <div>
                                                <button
                                                    className="btn btn-primary"
                                                    style={{width:'125px', marginBottom:'20px'}}
                                                    onClick={this.generateExport}>
                                                    {"Generate Export"}
                                                </button>
                                                <div className="alert alert-danger" role="alert">
                                                    {
                                                        this.state.textGenerate !== '' ? (
                                                            this.state.textGenerate+" Mungkin ini kan memakan waktu beberapa menit"
                                                        ):"Report Excel belum dibuat, Klik tombol diatas untuk export laporan presensi"
                                                    }
                                                </div>
                                            </div>
                                        )
                                    ) : (
                                        <div>
                                            <div className="alert alert-info" role="alert" style={{ textAlign:'center' }}>
                                                Report Excel siap di Unduh, Klik tombol bawah untuk unduh laporan
                                                presensi
                                                <br/>
                                                {this.state.created_at !== '' ? this.state.created_at : '-'}
                                                <br/>
                                                <button
                                                    className="btn btn-danger"
                                                    disabled={this.state.isButtonLoading && "disabled" && "disabled"}
                                                    onClick={this.generateExport}>
                                                    <i className=" fa fa-refresh"></i>
                                                    {this.state.isButtonLoading  ? " Loading.." : " Generate Ulang"}
                                                </button>
                                                <br/>
                                                <button
                                                    className="btn btn-primary"
                                                    style={{ marginTop:'30px' }}
                                                    onClick={this.exportFile}>
                                                    <i className=" fa fa-download"></i>
                                                    <ReactHTMLTableToExcel
                                                        id="test-table-xls-button"
                                                        className="download-table-xls-button"
                                                        table="table-to-xls"
                                                        filename="Report Presensi"
                                                        sheet="Report Presensi"
                                                        buttonText={"Download File"}
                                                    />
                                                </button>

                                            </div>
                                            <table className="table table-bordered" id="table-to-xls"
                                                   style={{display: 'none'}}>
                                                <tr>
                                                    <td colSpan={3}>Rekap Presensi</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={3}>Kelas
                                                        : {this.state.dKelas !== null ? this.state.dKelas.kelas_nama : 'Semua'}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={3}>Periode
                                                        : {urlParams.tglMulai + ' Sampai ' + urlParams.tglEnd}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={5}></td>
                                                </tr>
                                                <tr>
                                                    <th rowSpan={2}>No</th>
                                                    <th rowSpan={2}>Nama Guru</th>
                                                    <th rowSpan={2}>Kelas</th>
                                                    <th rowSpan={2}>In/Out</th>
                                                    <th colSpan={arrayDate.length * 2}>Tanggal</th>
                                                    <th colSpan={4}>Rekap</th>
                                                    <th rowSpan={2}>Total Hadir</th>
                                                    <th rowSpan={2}>Total Telat</th>
                                                </tr>
                                                <tr>
                                                    {
                                                        arrayDate.map((m,i) => {
                                                            return (
                                                                <td colSpan={2} key={i} style={{textAlign: "center"}}>{m.format("DD-MMM")}</td>
                                                            )
                                                        })
                                                    }
                                                    <td>Telat:</td>
                                                    <td>Izin:</td>
                                                    <td>Sakit:</td>
                                                    <td>Alpha:</td>
                                                </tr>
                                                {
                                                    this.state.dataExport.map((item) => {
                                                        return (
                                                            <tbody>
                                                            <tr>
                                                                <td rowSpan="2">{no++}</td>
                                                                <td rowSpan="2">{item.user_nama}</td>
                                                                <td rowSpan="2">{item.kelas_nama}</td>
                                                                <td>In</td>
                                                                {
                                                                    item.pre.map((items, i) => {
                                                                        if (items.in !== null) {
                                                                            if (items.in.presensi_status !== 'absent') {
                                                                                return (
                                                                                    <td key={i} rowSpan={1} colSpan={2} style={{textAlign: "center"}}>
                                                                                        {items.in.presensi_create_time}
                                                                                        <br/>
                                                                                        {items.telat > 0 ? 'Telat '+ items.waktuTelat+ ' Menit' : ''}
                                                                                    </td>
                                                                                )
                                                                            } else {
                                                                                return (
                                                                                    <td key={i} rowSpan={1} colSpan={2} style={{textAlign: "center"}}>{items.in.status_izin}</td>
                                                                                )
                                                                            }
                                                                        } else if (items.in == null && items.out == null && !items.libur) {
                                                                            return (
                                                                                <td rowSpan={2} colSpan={2}  key={i} style={{textAlign: "center"}}>Alpha</td>
                                                                            )
                                                                        }else if (items.in == null && items.out !== null) {
                                                                            return (
                                                                                <td rowSpan={1} colSpan={2}  key={i} style={{textAlign: "center"}}>-</td>
                                                                            )
                                                                        } else if (items.libur) {
                                                                            return (
                                                                                <td rowSpan={2} colSpan={2} key={i} style={{textAlign: "center"}}>LIBUR</td>
                                                                            )
                                                                        } else {
                                                                            return (
                                                                                <td rowSpan={2} colSpan={2}>-</td>
                                                                            )
                                                                        }

                                                                    })
                                                                }

                                                                <td rowSpan="2">{item.tot.telat}</td>
                                                                <td rowSpan="2">{item.tot.izinNonSakit}</td>
                                                                <td rowSpan="2">{item.tot.sakit}</td>
                                                                <td rowSpan="2">{item.tot.alpha}</td>
                                                                <td rowSpan="2">{item.tot.hadirWithTelat}</td>
                                                                <td rowSpan="2">
                                                                    {
                                                                        item.tot.waktuTelat > 0 ? Math.floor(item.tot.waktuTelat / 60)+' Jam, '+(item.tot.waktuTelat % 60)+' Menit' : '0'
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Out</td>
                                                                {
                                                                    item.pre.map((items) => {
                                                                        if (items.out !== null) {
                                                                            if (items.out.presensi_status !== 'absent') {
                                                                                return (
                                                                                    <td rowSpan={1} colSpan={2} style={{textAlign: "center"}}>{items.out.presensi_create_time}</td>)
                                                                            } else {
                                                                                return (
                                                                                    <td rowSpan={1} colSpan={2} style={{textAlign: "center"}}>{items.out.status_izin}</td>)
                                                                            }
                                                                        } else {
                                                                            return (
                                                                                " "
                                                                            )
                                                                        }

                                                                    })
                                                                }
                                                            </tr>
                                                            </tbody>

                                                        )
                                                    })
                                                }
                                            </table>
                                        </div>
                                    )
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ExportGuru;



// WEBPACK FOOTER //
// ./src/views/ReportPresensi/ExportGuru.js